import { createContext } from "react";

type VolumeContextType = {
    volume: number,
    setVolume: React.Dispatch<React.SetStateAction<number>>
}

const iVolumeContextState = {
    volume: 0,
    setVolume: () => {}
}

const VolumeContext = createContext<VolumeContextType>(iVolumeContextState)

export default VolumeContext